export const COLOR_HUES = {
    red: 8,
    purple: 267,
    blue: 221,
    yellow: 39,
    green: 149,
}
